export default "__VITE_ASSET__ccd23bba__"